import { useERPState } from 'views/Management/ERP/state';
import { useMemo } from 'react';
import { toNumber } from 'lodash-es';

export const useIsERP = (storeId: number | string) => {
  const { erpList } = useERPState();

  return useMemo(() => {
    return erpList.some(({ storeIds }) => storeIds.includes(toNumber(storeId)));
  }, [erpList, storeId]);
};
